import { rgba } from "@ancon/wildcat-ui/shared";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faCheck,
  faPlus,
  faMinus,
  faArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import { useFormContext } from "react-hook-form";
import { styled } from "styled-components";

import { FontVariant } from "../../constants/fonts";
import { ThemeFormValuesType } from "../../forms/app/ThemeForm";

const Container = styled.div`
  height: 836px;
  width: 393px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const CircleButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  height: 40px;
  width: 40px;
  border-radius: 50%;
`;

const TopBar = styled.div`
  width: 100%;
  padding: 20px 20px;
  display: flex;
  flex-direction: row;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  box-shadow: 2px 10px 20px rgba(0, 98, 103, 0.1);
`;

const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 0px;
  overflow: scroll;
`;

const Title = styled.h4`
  font-size: 18px;
  font-weight: 400;
  text-align: start;
  padding: 0px 20px;
`;

const TopBarRightContainer = styled.div`
  width: 40px;
`;

const Price = styled.h4`
  text-align: start;
  padding: 0px 20px;
`;

const AdvancePriceContainer = styled.div`
  padding: 7px 20px;
  margin-bottom: 35px;
  border-radius: 4px;
  width: 140px;
  margin-left: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Separator = styled.hr`
  margin: 0px;
`;

const Section = styled.div`
  padding-bottom: 20px;
`;

const SectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
`;

const SectionTitle = styled.div``;

const SectionBody = styled.div`
  padding: 10px 20px;
`;

const AccordionToggle = styled(CircleButton)`
  height: 32px;
  width: 32px;
  fontsize: 18px;
`;

const SectionItem = styled.div`
  padding: 5px 0px;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
`;

const RadioButton = styled.div`
  height: 20px;
  width: 20px;
  border-radius: 50%;
  border: 1px solid;
  margin-right: 20px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const Checkbox = styled.div`
  height: 20px;
  width: 20px;
  border-radius: 5px;
  border: 1px solid;
  margin-right: 20px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const RadioButtonSelection = styled.div`
  height: 12px;
  width: 12px;
  border-radius: 50%;
`;

const QuantityModifier = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 12px;
  padding: 12px;
  border-radius: 10px;
  width: 115px;
  margin-right: 20px;
`;

const Footer = styled.div`
  border-top: 1px solid;
  width: 100%;
  padding: 20px 20px;

  display: flex;
  flex-direction: column;
  width: 100%;
`;

const ActionContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const AddToCart = styled.div`
  flex: 1;
  width: 100%;
  height: 40px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SectionError = styled.div`
  padding: 7px 20px;
  text-align: start;
  font-size: 12px;
`;

const FooterError = styled.div`
  text-align: start;
  margin-bottom: 7px;
`;

export default function PrimaryThemePreview() {
  const { watch } = useFormContext<ThemeFormValuesType>();
  const values = watch();
  const { primary, secondary, tertiary, isWL } = values;
  const {
    color: tertiaryColor,
    surfaces: tertiarySurfaces,
    content: tertiaryContent,
  } = tertiary;
  const { color: secondaryColor, content: secondaryContent } = secondary;
  const {
    color: primaryColor,
    content,
    buttons,
    highlights,
    surfaces,
  } = primary;
  const { default: defaultHighLight } = highlights;
  const { default: defaultButton } = buttons;
  const { default: defaultContentColor, danger: dangerContentColor } = content;
  const { default: defaultSurfaceColor } = surfaces;
  const { default: defaultTertiarySurface } = tertiarySurfaces;

  return (
    <Container style={{ backgroundColor: primaryColor }}>
      <TopBar
        style={{
          backgroundColor: isWL ? tertiaryColor : secondaryColor,
        }}
      >
        <CircleButton
          style={{
            backgroundColor: defaultButton.color,
          }}
        >
          <FontAwesomeIcon
            icon={faArrowLeft}
            size="xs"
            color={defaultButton.content}
          />
        </CircleButton>
        <Title
          style={{
            color: isWL ? secondaryColor : secondaryContent.default,
            fontFamily: FontVariant.PrimaryRegular,
          }}
        >
          Pizza Margaherita
        </Title>
        <TopBarRightContainer />
      </TopBar>

      <ContentContainer>
        <Title
          style={{
            color: defaultContentColor,
            fontFamily: FontVariant.PrimaryBold,
          }}
        >
          Pizza Margaherita
        </Title>
        <Price
          style={{
            color: defaultContentColor,
            fontFamily: FontVariant.PrimaryRegular,
          }}
        >
          11 kr
        </Price>

        <AdvancePriceContainer
          style={{
            color: defaultContentColor,
            backgroundColor: defaultHighLight,
            fontFamily: FontVariant.PrimaryRegular,
          }}
        >
          Happy Hour
        </AdvancePriceContainer>
        <Separator style={{ background: defaultButton.disabled }} />
        <Section>
          <SectionHeader>
            <SectionTitle
              style={{
                color: defaultContentColor,
                fontFamily: FontVariant.PrimaryRegular,
              }}
            >
              Variants
            </SectionTitle>
            <AccordionToggle
              style={{
                backgroundColor: defaultButton.color,
                color: defaultButton.content,
              }}
            >
              <FontAwesomeIcon
                size="xs"
                icon={faChevronDown}
                color={defaultButton.content}
              />
            </AccordionToggle>
          </SectionHeader>
          <SectionBody>
            <SectionItem
              style={{
                color: defaultContentColor,
                fontFamily: FontVariant.PrimaryRegular,
              }}
            >
              <RadioButton
                style={{
                  backgroundColor: primaryColor,
                  borderColor: defaultContentColor,
                }}
              />
              Margherita
            </SectionItem>
            <SectionItem
              style={{
                color: defaultContentColor,
                fontFamily: FontVariant.PrimaryRegular,
              }}
            >
              <RadioButton
                style={{
                  backgroundColor: primaryColor,
                  borderColor: defaultContentColor,
                }}
              >
                <RadioButtonSelection
                  style={{ backgroundColor: defaultHighLight }}
                />
              </RadioButton>
              Margherita
            </SectionItem>

            <SectionItem
              style={{
                color: defaultContentColor,
                fontFamily: FontVariant.PrimaryRegular,
              }}
            >
              <Checkbox />
              Bacon
            </SectionItem>
            <SectionItem
              style={{
                color: defaultContentColor,
                fontFamily: FontVariant.PrimaryRegular,
              }}
            >
              <Checkbox
                style={{
                  backgroundColor: defaultHighLight,
                }}
              >
                <FontAwesomeIcon
                  size="xs"
                  icon={faCheck}
                  color={defaultButton.content}
                />
              </Checkbox>
              Bacon
            </SectionItem>
            <SectionItem
              style={{
                color: defaultContentColor,
                backgroundColor: primaryColor,
                fontFamily: FontVariant.PrimaryRegular,
              }}
            >
              <QuantityModifier
                style={{
                  backgroundColor: isWL
                    ? defaultTertiarySurface.color
                    : primaryColor,
                  fontFamily: FontVariant.PrimaryRegular,
                }}
              >
                <FontAwesomeIcon
                  size="xs"
                  icon={faMinus}
                  color={defaultContentColor}
                />
                10
                <FontAwesomeIcon
                  size="xs"
                  icon={faPlus}
                  color={defaultContentColor}
                />
              </QuantityModifier>
              Garlic Bread
            </SectionItem>
          </SectionBody>
        </Section>
        <Separator style={{ background: defaultButton.disabled }} />
        <Section>
          <SectionHeader>
            <SectionTitle
              style={{
                color: defaultContentColor,
                fontFamily: FontVariant.PrimaryRegular,
              }}
            >
              Ingredients
            </SectionTitle>
            <AccordionToggle
              style={{
                backgroundColor: defaultButton.color,
                color: defaultButton.content,
              }}
            >
              <FontAwesomeIcon
                size="xs"
                icon={faChevronDown}
                color={defaultButton.content}
              />
            </AccordionToggle>
          </SectionHeader>
          <SectionError
            style={{
              backgroundColor: rgba(defaultSurfaceColor.color, 0.7),
              color: defaultSurfaceColor.content.default,
              fontFamily: FontVariant.PrimaryRegular,
            }}
          >
            Mandatory Selection
          </SectionError>
          <SectionBody
            style={{ backgroundColor: rgba(dangerContentColor, 0.04) }}
          >
            <SectionItem
              style={{
                color: defaultContentColor,
                fontFamily: FontVariant.PrimaryRegular,
              }}
            >
              <RadioButton
                style={{
                  backgroundColor: primaryColor,
                  borderColor: defaultContentColor,
                }}
              />
              Margherita
            </SectionItem>
            <SectionItem
              style={{
                color: defaultContentColor,
                fontFamily: FontVariant.PrimaryRegular,
              }}
            >
              <RadioButton
                style={{
                  backgroundColor: primaryColor,
                  borderColor: defaultContentColor,
                }}
              >
                <RadioButtonSelection
                  style={{ backgroundColor: defaultHighLight }}
                />
              </RadioButton>
              Margherita
            </SectionItem>
          </SectionBody>
        </Section>
      </ContentContainer>
      <Footer
        style={{
          borderTopColor: defaultButton.disabled,
          backgroundColor: isWL ? defaultTertiarySurface.color : primaryColor,
        }}
      >
        <FooterError
          style={{
            color: rgba(dangerContentColor, 0.7),
            fontFamily: FontVariant.PrimaryRegular,
          }}
        >
          Out of stock
        </FooterError>
        <ActionContainer>
          <QuantityModifier
            style={{
              backgroundColor: defaultTertiarySurface.color,
              fontFamily: FontVariant.PrimaryRegular,
            }}
          >
            <FontAwesomeIcon
              size="xs"
              icon={faMinus}
              color={defaultContentColor}
            />
            10
            <FontAwesomeIcon
              size="xs"
              icon={faPlus}
              color={defaultContentColor}
            />
          </QuantityModifier>

          <AddToCart
            style={{
              backgroundColor: defaultButton.color,
              color: isWL ? tertiaryContent.default : defaultButton.content,
              fontFamily: FontVariant.PrimaryRegular,
            }}
          >
            Add To Cart
          </AddToCart>
        </ActionContainer>
      </Footer>
    </Container>
  );
}
